<template>
  <li class="submenu-category-item">
    <VNuxtLink
      :to="useNamedRoutes({ name: 'documents' })"
      class="d-flex border-top ms-4 me-7 pt-4 pb-2 d-flex flex-grow-1 align-items-center transiton text-black fw-bold"
    >
      {{ $t('Dokumenty') }}
      <img
        loading="lazy"
        decoding="async"
        src="~/assets/icons/long-arrow-right.svg"
        class="d-inline-block ms-2"
        width="15"
        height="8"
        alt=""
      >
    </VNuxtLink>
  </li>

  <li class="submenu-category-item">
    <VNuxtLink
      :to="useNamedRoutes({ name: 'faq' })"
      class="d-flex ms-4 me-7 d-flex py-2 flex-grow-1 align-items-center transiton text-black fw-bold"
    >
      {{ $t('Často kladené otázky') }}
      <img
        loading="lazy"
        decoding="async"
        src="~/assets/icons/long-arrow-right.svg"
        class="d-inline-block ms-2"
        width="15"
        height="8"
        alt=""
      >
    </VNuxtLink>
  </li>
</template>

<style lang="scss">
@import '../category/SubmenuCategory.scss';
</style>
